var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 8"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-2h12v12H-1z",
    fillOpacity: 0,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.177 6.224l-2.61-2.61a.545.545 0 10-.77.772L3.85 7.44a.545.545 0 00.822-.058l4.582-6.11a.545.545 0 00-.873-.654L4.177 6.224z"
  }))));
};
export { SvgCheck as ReactComponent };
export default "data:image/svg+xml,export default 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMTAgOCI+CiAgICA8ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGZpbGw9Im5vbmUiIGQ9Ik0tMS0yaDEydjEySC0xeiIgZmlsbC1vcGFjaXR5PSIwIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz4KICAgICAgICA8cGF0aCBkPSJNNC4xNzcgNi4yMjRsLTIuNjEtMi42MWEuNTQ1LjU0NSAwIDEwLS43Ny43NzJMMy44NSA3LjQ0YS41NDUuNTQ1IDAgMDAuODIyLS4wNThsNC41ODItNi4xMWEuNTQ1LjU0NSAwIDAwLS44NzMtLjY1NEw0LjE3NyA2LjIyNHoiLz4KICAgIDwvZz4KPC9zdmc+'";